import { MatchFillWidget } from "../../../../components/MatchFillWidget/MatchFillWidget";
import type { EventsWidgetProvider } from "./types";

export const matchFillProvider: EventsWidgetProvider = {
  id: "match-fill",

  match({ store }) {
    const pastSparks = store.pastSparks ?? [];
    // Which category this viewer actually matches in. Friends Only users get
    // every participant back as "friend", so a hardcoded "dating" here hid
    // this widget from them entirely — the app promised they'd "still match as
    // friends after events" and then never offered them the way to do it.
    const friendsOnly = store.user?.friends_only ?? false;
    const wanted = friendsOnly ? "friend" : "dating";
    for (const spark of pastSparks) {
      if (spark.matchesCompleted) continue;
      const candidates = spark.participants
        .filter((p) => p.category === wanted && p.status === null)
        .sort((a, b) => {
          const aHasMedia = Object.keys(a.media).length > 0 ? 1 : 0;
          const bHasMedia = Object.keys(b.media).length > 0 ? 1 : 0;
          return bHasMedia - aHasMedia;
        });
      if (!candidates.length) continue;
      return {
        key: `match-fill-${spark.id}`,
        subheading: friendsOnly
          ? "Meet your new friends!"
          : "It's time to match!",
        render: () => (
          <MatchFillWidget
            sparkId={spark.id}
            candidates={candidates}
            category={friendsOnly ? "friend" : "dating"}
            event={{
              title: spark.title,
              activity: spark.activity,
              starts_at: spark.starts_at,
              primary_image: spark.primary_image,
              hero_image: spark.hero_image,
            }}
          />
        ),
      };
    }
    return null;
  },
};
